(function(){
  // Sizes from the 3D Leggings V2 chart (screenshot). Waist and hip are the screenshot values
  // turned into ranges: each value is the low bound, the next size is the high bound. Length in cm.
  var SIZES=[
    {key:'S',  us:'4-6',  ca:'4-6',  uk:'8-10', eu:'36-38', au:'8-10', nz:'8-10', wCm:'58-62', hCm:'68-72', lCm:79, wMaxCm:62, hMaxCm:72},
    {key:'M',  us:'6-8',  ca:'6-8',  uk:'10-12',eu:'38-40', au:'10-12',nz:'10-12',wCm:'62-66', hCm:'72-76', lCm:81, wMaxCm:66, hMaxCm:76},
    {key:'L',  us:'8-10', ca:'8-10', uk:'12-14',eu:'40-42', au:'12-14',nz:'12-14',wCm:'66-70', hCm:'76-80', lCm:83, wMaxCm:70, hMaxCm:80},
    {key:'XL', us:'12-14',ca:'12-14',uk:'14-16',eu:'42-44', au:'14-16',nz:'14-16',wCm:'70-74', hCm:'80-84', lCm:85, wMaxCm:74, hMaxCm:84},
    {key:'2XL',us:'14-16',ca:'14-16',uk:'16-18',eu:'44-46', au:'16-18',nz:'16-18',wCm:'74-78', hCm:'84-88', lCm:87, wMaxCm:78, hMaxCm:88},
    {key:'3XL',us:'16-18',ca:'16-18',uk:'18-20',eu:'46-48', au:'18-20',nz:'18-20',wCm:'78-82', hCm:'88-92', lCm:89, wMaxCm:82, hMaxCm:92},
    {key:'4XL',us:'18-20',ca:'18-20',uk:'20-22',eu:'48-50', au:'20-22',nz:'20-22',wCm:'82-86', hCm:'92-96', lCm:91, wMaxCm:86, hMaxCm:96},
    {key:'5XL',us:'20-22',ca:'20-22',uk:'22-24',eu:'50-52', au:'22-24',nz:'22-24',wCm:'86-90', hCm:'96-100',lCm:93, wMaxCm:90, hMaxCm:100}
  ];

  // Impact port: one resolver for every "send them to the offer" jump.
  // Kaching injects late, so this runs at click time, never at load time.
  // Cascade, most specific first, falling back to whatever Impact does render.
  function scrollTarget(){
    var sels=[
      '.kaching-bundles__bar',
      '[class*="kaching-bundles__bar" i]',
      '[class*="kaching-bundles" i]',
      '[id^="shopify-section-template"][id$="__main"]',
      'product-info',
      'product-form',
      '.shopify-payment-button'
    ];
    for(var i=0;i<sels.length;i++){
      var list=document.querySelectorAll(sels[i]);
      for(var j=0;j<list.length;j++){
        var el=list[j];
        if(el.closest('.cm-ff')||el.closest('.cm-ff__overlay')) continue;
        if(el.getBoundingClientRect().height>0) return el;
      }
    }
    return null;
  }

  var root=document.querySelector('.cm-ff');
  var overlay=root.querySelector('[data-ff-overlay]');
  var steps=root.querySelectorAll('.cm-ff__step');
  var progress=root.querySelector('[data-ff-progress]');
  var backLabel=root.querySelector('[data-ff-back-label]');
  var moreBtn=root.querySelector('[data-more]');
  var state={step:0, height:165, hUnit:'cm', weight:65, wUnit:'kg', age:null, prop:0, tight:0, ex:{on:false, unit:'cm', waist:null, hip:null}};
  var TOTAL=6;
  var analysisTimer=null;

  // Portal the overlay straight to <body> once, so no transformed or overflow-clipped
  // theme ancestor can trap its position:fixed and cut the modal off at the page edge.
  if(overlay.parentNode!==document.body){ document.body.appendChild(overlay); }

  function exactReady(){ return state.ex.on && state.ex.waist && state.ex.hip; }

  function show(n){
    clearInterval(analysisTimer);
    state.step=n;
    steps.forEach(function(s){ s.classList.toggle('is-active', +s.dataset.step===n); });
    progress.style.width=Math.round(((n+1)/TOTAL)*100)+'%';
    backLabel.textContent = n===0 ? (backLabel.getAttribute('data-close') || 'Close') : (backLabel.getAttribute('data-back') || 'Back');
    overlay.querySelector('.cm-ff__stage').scrollTop=0;
    overlay.scrollTop=0;
    if(n===4){ runAnalysis(); }
  }

  root.querySelector('[data-ff-open]').addEventListener('click',function(){ overlay.hidden=false; document.body.style.overflow='hidden'; show(0); });
  function close(){ clearInterval(analysisTimer); overlay.hidden=true; document.body.style.overflow=''; }
  overlay.addEventListener('click',function(e){ if(e.target===overlay) close(); });

  overlay.querySelector('[data-ff-back]').addEventListener('click',function(){
    if(state.step===0) close();
    else if(state.step===4 || state.step===5) show(exactReady() ? 1 : 3);
    else show(state.step-1);
  });

  overlay.querySelectorAll('[data-ff-next]').forEach(function(b){ b.addEventListener('click',function(){
    if(state.step===1 && exactReady()){ show(4); } else { show(state.step+1); }
  }); });
  overlay.querySelector('[data-ff-restart]').addEventListener('click',function(){ show(0); });

  // sliders
  function fmt(){
    overlay.querySelector('[data-out="height"]').textContent = state.hUnit==='cm' ? state.height : Math.round(state.height/2.54);
    overlay.querySelector('[data-unit="height"]').textContent=state.hUnit;
    overlay.querySelector('[data-out="weight"]').textContent = state.wUnit==='kg' ? state.weight : Math.round(state.weight*2.205);
    overlay.querySelector('[data-unit="weight"]').textContent=state.wUnit;
    overlay.querySelector('[data-out="age"]').textContent = state.age===null ? 'Skip' : state.age;
  }
  overlay.querySelector('[data-input="height"]').addEventListener('input',function(){ state.height=+this.value; fmt(); });
  overlay.querySelector('[data-input="weight"]').addEventListener('input',function(){ state.weight=+this.value; fmt(); });
  overlay.querySelector('[data-input="age"]').addEventListener('input',function(){ state.age = +this.value===16 ? null : +this.value; fmt(); });

  // toggles (height, weight, exact units)
  overlay.querySelectorAll('.cm-ff__toggle').forEach(function(t){
    var which=t.dataset.toggle;
    t.querySelectorAll('button').forEach(function(btn){
      btn.addEventListener('click',function(){
        t.querySelectorAll('button').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if(which==='height') state.hUnit=btn.dataset.val;
        if(which==='weight') state.wUnit=btn.dataset.val;
        if(which==='exact') state.ex.unit=btn.dataset.val;
        fmt();
      });
    });
  });

  // hip proportion
  overlay.querySelectorAll('.cm-ff__shape').forEach(function(s){
    s.addEventListener('click',function(){
      overlay.querySelectorAll('.cm-ff__shape').forEach(function(x){ x.classList.remove('is-active'); });
      s.classList.add('is-active');
      state.prop=+s.dataset.prop;
    });
  });

  // tightness
  overlay.querySelectorAll('.cm-ff__tight').forEach(function(s){
    s.addEventListener('click',function(){
      overlay.querySelectorAll('.cm-ff__tight').forEach(function(x){ x.classList.remove('is-active'); });
      s.classList.add('is-active');
      state.tight=+s.dataset.tight;
    });
  });

  // exact measurements
  var exToggle=overlay.querySelector('[data-exact-toggle]');
  var exBlock=overlay.querySelector('.cm-ff__exact');
  exToggle.addEventListener('click',function(){
    if(exBlock.hasAttribute('hidden')){ exBlock.removeAttribute('hidden'); exToggle.classList.add('is-open'); state.ex.on=true; }
    else{ exBlock.setAttribute('hidden',''); exToggle.classList.remove('is-open'); state.ex.on=false; }
  });
  overlay.querySelectorAll('[data-ex]').forEach(function(inp){
    inp.addEventListener('input',function(){ var v=parseFloat(this.value); state.ex[this.dataset.ex]= isNaN(v)?null:v; });
  });

  // more toggle
  moreBtn=overlay.querySelector('[data-more]');
  moreBtn.addEventListener('click',function(){
    var body=overlay.querySelector('.cm-ff__more-body');
    if(body.hasAttribute('hidden')){ body.removeAttribute('hidden'); moreBtn.classList.add('is-open'); }
    else{ body.setAttribute('hidden',''); moreBtn.classList.remove('is-open'); }
  });

  // The product runs about one size small (Judge.me, 8330 reviews). This single knob
  // pushes every recommendation up one size. Validate the exact cm against flat garment
  // measurements and return/exchange data before locking the displayed ranges.
  var RUNS_SMALL=1;

  function computeSize(){
    var idx, fit, conf;
    if(exactReady()){
      var toCm=function(v){ return state.ex.unit==='in' ? v*2.54 : v; };
      var w=toCm(state.ex.waist);
      // Match on WAIST. The chart HIP column (68 to 100cm) does not match real body hips,
      // so it is not used for the decision until validated. Kamino: revisit once hip cm are confirmed.
      var wi=7;
      for(var i=0;i<SIZES.length;i++){ if(w<=SIZES[i].wMaxCm){ wi=i; break; } }
      idx = wi + RUNS_SMALL;
      if(idx>7) idx=7; if(idx<0) idx=0;
      fit = SIZES[Math.max(0, idx-RUNS_SMALL)];
      conf = 96;
    } else {
      var kg=state.weight, m=state.height/100, bmi=kg/(m*m), base;
      if(kg<62) base=0; else if(kg<70) base=1; else if(kg<80) base=2; else if(kg<90) base=3;
      else if(kg<100) base=4; else if(kg<110) base=5; else if(kg<120) base=6; else base=7;
      if(bmi<19) base-=1; else if(bmi>32) base+=1;
      idx = base + state.prop + state.tight + RUNS_SMALL;
      if(idx>7) idx=7; if(idx<0) idx=0;
      fit = SIZES[idx];
      conf = (state.prop===0 && state.tight===0) ? 92 : 89;
    }
    return {size:SIZES[idx], fit:fit, conf:conf};
  }

  function renderResult(r){
    var s=r.size;
    overlay.querySelector('[data-out="size"]').textContent=s.key;
    overlay.querySelector('[data-out="conf"]').textContent=r.conf;
    root.dataset.ffResult=s.key;
    overlay.querySelector('[data-out="detail"]').innerHTML=
      '<div><small>Fits waist</small><b>'+r.fit.wCm+' cm</b></div>'+
      '<div><small>Fits hips</small><b>'+r.fit.hCm+' cm</b></div>'+
      '<div><small>Length</small><b>'+s.lCm+' cm</b></div>';
    overlay.querySelector('[data-lengthwarn]').hidden = !(state.height>175);
    var conv=overlay.querySelector('[data-out="conv"]');
    conv.innerHTML='';
    [['US',s.us],['UK',s.uk],['EU',s.eu],['CA',s.ca],['AU',s.au],['NZ',s.nz]].forEach(function(c){
      var cell=document.createElement('div');
      cell.className='cm-ff__conv-cell';
      cell.innerHTML='<small>'+c[0]+'</small><b>'+c[1]+'</b>';
      conv.appendChild(cell);
    });
    overlay.querySelector('.cm-ff__more-body').setAttribute('hidden','');
    moreBtn.classList.remove('is-open');
  }

  function runAnalysis(){
    var lis=overlay.querySelectorAll('.cm-ff__analyse li');
    lis.forEach(function(li){ li.classList.remove('is-done'); });
    var i=0;
    analysisTimer=setInterval(function(){
      if(i<lis.length){ lis[i].classList.add('is-done'); i++; }
      else{
        clearInterval(analysisTimer);
        renderResult(computeSize());
        setTimeout(function(){ show(5); }, 450);
      }
    }, 620);
  }

  // apply: pick the variant, close, then take the shopper to the bundle or the add to cart.
  overlay.querySelector('[data-ff-apply]').addEventListener('click',function(){
    var size=root.dataset.ffResult;
    document.dispatchEvent(new CustomEvent('cm:size-selected',{detail:{size:size}}));

    // Best effort variant select, scoped to a real product form so we do not click random elements.
    // Kamino: if your variant picker uses a custom structure, target it explicitly here.
    try{
      var scope = document.querySelector('form[action*="/cart/add"]') || document;
      var candidates = scope.querySelectorAll(
        'variant-picker label, .variant-picker__option-value, .product-form__input label, fieldset label, [data-option-value], [data-value], .swatch, option'
      );
      for(var i=0;i<candidates.length;i++){
        var el=candidates[i];
        if(el.closest('.cm-ff')||el.closest('.cm-ff__overlay')) continue;
        var txt=(el.getAttribute('data-option-value')||el.getAttribute('data-value')||el.textContent||'').trim().toUpperCase();
        if(txt===size){
          if(el.tagName==='OPTION'){ el.selected=true; var sel=el.closest('select'); if(sel){ sel.dispatchEvent(new Event('change',{bubbles:true})); } }
          else { el.click(); }
          break;
        }
      }
    }catch(e){}

    close();

    // Send them to the bundle first, then fall back to the add to cart.
    setTimeout(function(){
      var target = scrollTarget();
      if(target){ target.scrollIntoView({behavior:'smooth', block:'center'}); }
    }, 120);
  });

  // Auto placement: drop the trigger right after the Kaching bundle (so it sits between the
  // bundle and the add to cart), and put it back if Kaching redraws.
  // Set data-ff-place other than "auto" to leave it where you paste it.
  //
  // Returns the OUTERMOST Kaching container, not the first match. Kaching marks every
  // offer row with a kaching-* class too, so "first match over 80px" landed on offer 2
  // and the trigger ended up mid-bundle. We gather all matches, drop anything nested
  // inside another match, and keep the tallest remaining root.
  function bundleEl(){
    var sels=['.kaching-bundles__bar','[class*="kaching-bundles__bar" i]','[data-kaching-bundles]','.kaching-bundles','[class*="kaching-bundles" i]','[class*="kaching" i]'];
    var found=[];
    for(var i=0;i<sels.length;i++){
      var list=document.querySelectorAll(sels[i]);
      for(var j=0;j<list.length;j++){
        var el=list[j];
        if(el.closest('.cm-ff__overlay')||el.closest('.cm-ff__triggerwrap')) continue;
        if(el.contains(root)) continue; // never anchor on an ancestor of the whole widget
        var r=el.getBoundingClientRect();
        if(r.height>40 && r.width>80 && found.indexOf(el)===-1) found.push(el);
      }
    }
    if(!found.length) return null;

    var roots=found.filter(function(el){
      return !found.some(function(other){ return other!==el && other.contains(el); });
    });
    var pool = roots.length ? roots : found;
    pool.sort(function(a,b){
      return b.getBoundingClientRect().height - a.getBoundingClientRect().height;
    });
    return pool[0];
  }
  function atcEl(){
    var sels=['buy-buttons','.product-form__buttons','[data-shopify="payment-button"]','button[name="add"]','.shopify-payment-button','form[action*="/cart/add"] button[type="submit"]'];
    for(var i=0;i<sels.length;i++){
      var list=document.querySelectorAll(sels[i]);
      for(var j=0;j<list.length;j++){
        var el=list[j];
        if(el.closest('.cm-ff__overlay')||el.closest('.cm-ff__triggerwrap')) continue;
        if(el.closest('[class*="sticky" i]')) continue; // skip the sticky bar, we want the buy box
        var r=el.getBoundingClientRect();
        if(r.height>20) return el;
      }
    }
    return null;
  }
  function place(wrap){
    if(wrap.getAttribute('data-ff-place')!=='auto') return true;
    var b=bundleEl();
    if(b && b.parentNode && !b.contains(wrap)){
      if(b.nextElementSibling===wrap) return true;
      b.insertAdjacentElement('afterend', wrap);
      return true;
    }
    var a=atcEl();
    if(a){
      var host=a.closest('buy-buttons')||a.closest('.product-form__buttons')||a;
      if(host.previousElementSibling===wrap) return true;
      host.parentNode.insertBefore(wrap, host);
      return true;
    }
    return false;
  }
  function watchPlacement(){
    var wrap=root.querySelector('.cm-ff__triggerwrap[data-ff-place="auto"]') || document.querySelector('.cm-ff__triggerwrap[data-ff-place="auto"]');
    if(!wrap) return;
    place(wrap);
    var t=null;
    var mo=new MutationObserver(function(){
      clearTimeout(t);
      t=setTimeout(function(){ if(wrap.isConnected) place(wrap); }, 200);
    });
    mo.observe(document.body,{childList:true, subtree:true});
    [400,1000,2200,4000].forEach(function(ms){ setTimeout(function(){ if(wrap.isConnected) place(wrap); }, ms); });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', watchPlacement); }
  else { watchPlacement(); }

  fmt();
})();